import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import { makeStyles } from '@material-ui/core/styles';

import Translate from '@hydra/common/components/i18n';
import Flag from '@hydra/common/components/Flag';

import CriteriumText from '@hydra/common/criterium/CriteriumText';
import Criterium from '@hydra/common/criterium/Criterium';

import tldToCountryCode from '@hydra/utils/tldToCountryCode';

const useStyles = makeStyles(theme => ({
  flag: {
    margin: theme.spacing(0, 1)
  }
}));

export const IpInformation = ({ criterium }) => {
  const classes = useStyles();
  const { data } = criterium;

  const countryCode = get(data, ['location', 'countryCode'], '').toLowerCase();
  const cityName = get(data, ['location', 'cityName'], '');

  const secondLine = (countryCode && cityName)
    ? (
      <>
        <Translate content='review_ip_location' component='strong' />
        <span className={classes.flag}><Flag country={tldToCountryCode(countryCode)} /></span>
        {cityName}
      </>
      )
    : null;

  const content = <CriteriumText firstLine={data.ip} secondLine={secondLine} />;

  return <Criterium criterium={criterium}>{content}</Criterium>;
};

IpInformation.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      ip: PropTypes.string,
      location: PropTypes.shape({
        cityName: PropTypes.string,
        countryCode: PropTypes.string
      })
    })
  })
};

export default React.memo(IpInformation);
